import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FirebaseService } from 'src/app/core/services/firebase.service';
import { ErrorService } from 'src/app/core/services/error.service';
import { CrateItem } from '../pallet-details.component';
@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss']
})
export class ProductDetailsComponent implements OnInit, OnChanges {
  @Input() product!: CrateItem;
  
  isLoading = false;
  url: string;

  @Output() click = new EventEmitter<{product: CrateItem, url: string}>();

  constructor(
    private firebaseService: FirebaseService,
    private errorService: ErrorService
  ) { }

  ngOnInit(): void {
  }

  imageClicked($event) {
    this.click.emit({product: this.product, url: this.url});
    $event.stopPropagation();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['product']) {
      this.isLoading = true;
      this.getProductImage().then((url) => {
        this.url = url;
      }).finally(() => {
        this.isLoading = false;
      });
    }
  }

  async getProductImage(): Promise<string> {
    const productImageUrl = await this.firebaseService.getProductImage(this.product.sku);
    return productImageUrl;
  }
} 